var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.badgeClasses},[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }